@for ( fieldDef of componentDef?.fields; track fieldDef.name; let first =
$first) { @switch (fieldDef.type) { @case (badgeType) {

<span
  class="badge indicator indicator__label"
  [attr.data-e2e]="fieldDef.name"
  [ngClass]="fieldDef.className"
  [style.color]="fieldDef.color"
  [style.background-color]="fieldDef.backgroundColor"
>
  @if (fieldDef.icon) {
  <fa-icon class="mr-1" size="xs" [icon]="fieldDef.icon"></fa-icon>
  }
  {{ fieldDef.label }}
</span>

} @case (textType) {
<span class="indicator indicator__label" [ngClass]="fieldDef.className">{{
  fieldDef.label
}}</span>
} @case (customIconType) {
<div
  class="text-primary d-inline-block custom-icon indicator"
  [ngClass]="fieldDef.className"
>
  <atx-custom-icon
    class="mr-1"
    [icon]="fieldDef.icon"
    [path]="customIconsPath"
    [atxTooltip]="fieldDef.tooltip"
    tooltipPlacement="left"
    [attr.data-e2e]="fieldDef.name"
    [ngClass]="getIconClass(fieldDef.color)"
  ></atx-custom-icon>
  @if (fieldDef.showLabel) {
  <span>
    {{ fieldDef.label || '' }}
  </span>
  }
</div>
} @default {
<span
  [class.ml-1]="!first"
  [atxTooltip]="fieldDef.tooltip"
  tooltipPlacement="left"
  [ngClass]="fieldDef.className"
>
  <fa-icon [icon]="fieldDef.icon" [attr.data-e2e]="fieldDef.name"></fa-icon>
</span>
} } }
